import React from 'react';

import { useSelector } from 'react-redux';

import UserProfileCompletionThailandForm from '@/components/shared/complete-profile/UserProfileCompletionThailandForm';
import UserProfileCompletionForm from '@/components/shared/complete-profile/UserProfileCompletionForm';
import { selectIsFastRegTh } from '@/store/selectors/userSelectors';

const UserCompleteProfileFormManager = ({ onSuccess }: { onSuccess?: VoidFunction }) => {
  const isFastRegTh = useSelector(selectIsFastRegTh);

  if (isFastRegTh) {
    return <UserProfileCompletionThailandForm onSuccess={onSuccess} />;
  }

  return <UserProfileCompletionForm onSuccessCallback={onSuccess} />;
};

export default UserCompleteProfileFormManager;
